<!-- // NOT IN USE - possibly delete -->
<template>
  <div class="mouse-tooltip hide-for-print" v-if="data && data.style">
    <transition name="fade">
      <div
        id="mousetooltip"
        class="mouse-tooltip__tooltip"
        :style="positionStyle"
        v-if="(visible !== false)"
      >
        <div class="linetooltip" v-if="data.style === 'linechart'">
          <div class="inner" v-for="info in data.data.dataarr">
            <div class="linetooltip__label" v-html="info.label"></div>
            <div class="linetooltip__row">
              <div class="col6 linetooltip__year" v-html="info.year"></div>
              <div class="col6 linetooltip__value" v-html="getFixedValue(info.value)"></div>
            </div>
          </div>
        </div>

        <div class="germany" v-if="data.style === 'germany'">
          <div class="linetooltip__row" v-if="data.values['Germany']">
            <div class="col6 linetooltip__year">Germany</div>
            <div class="col6 linetooltip__value" v-html="getFixedValue(data.values['Germany'])"></div>
          </div>
          <div class="linetooltip__row" v-if="data.values['German Democratic Republic']">
            <div class="col6 linetooltip__year">German Democratic Republic</div>
            <div class="col6 linetooltip__value" v-html="getFixedValue(data.values['German Democratic Republic'])"></div>
          </div>
        </div>

        <div class="map" v-if="data.style === 'map'">
          <div class="map__wrap">
            <div class="map__wrap__label" v-html="data.label"></div>
            <div class="map__wrap__value" v-html="getFixedValue(data.value)"></div>
          </div>
          <div class="map__sublabel" v-if="data.sublabel" v-html="data.sublabel"></div>
        </div>

        <div class="multiline" v-if="data.style === 'multiline'">
          <div class="multiline__label" v-if="data.label" v-html="data.label"></div>
          <div class="multiline__sublabel" v-if="data.sublabel" v-html="data.sublabel"></div>
          <div class="multiline__values" v-if="data.value">
            <div class="multiline__values__value" v-for="(val, i) of data.value" :key="i" v-html="val"></div>
          </div>
        </div>

        <div class="multiline country-info" v-if="data.style === 'country-info'">
          <div class="multiline__label" v-if="data.label" v-html="data.label"></div>
          <div class="multiline__sublabel" v-if="data.sublabel" v-html="data.sublabel"></div>
          <div class="multiline__values" v-if="data.value">
            <div class="multiline__values__value" v-for="(val, i) of data.value" :key="i" >
              <span v-html="val.label"></span>
              <span v-html="val.value"></span>
            </div>
          </div>
        </div>

        <div class="single" v-if="data.style === 'single'">
          <div class="single__label" v-html="data.label"></div>
          <a target="_blank" class="single__link" :href="data.link" v-if="data.link && data.link !== ''">{{ this.$Strings('tooltip_readmore') }}</a>
        </div>

      </div>
    </transition>
  </div>
</template>

<script>
import {EventBus} from '@/event-bus.js'

export default {
  name: 'mouse-tooltip',
  data () {
    return {
      data: {},
      visible: false,
      positionStyle: {},
      positionOffset: { x: 10, y: 10 }
    }
  },
  created () {
    EventBus.$on('tooltip.show', this.show)
    EventBus.$on('tooltip.hide', this.hide)
  },
  mounted () {
    EventBus.$on('mousemove', () => {
      if (this.data.followMouse === undefined || this.data.followMouse === true) {
        this.setPosition()
      } else {
        this.closeOnMouseLeave()
      }
    })
  },
  destroyed () {
    // Remove event handlers
    EventBus.$off('tooltip.open')
    EventBus.$off('tooltip.close')
  },
  computed: {
    mouseX () {
      return parseInt(this.$store.state.mousePosition.x)
    },
    mouseY () {
      return parseInt(this.$store.state.mousePosition.y)
    }
  },
  methods: {
    getElementPosition () {
      if (!document.getElementById('mousetooltip')) return { t: 0, l: 0, w: 0, h: 0 }

      let elem = document.getElementById('mousetooltip')

      let box = elem.getBoundingClientRect()

      let body = document.body
      let docEl = document.documentElement

      let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop
      let scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft

      let clientTop = docEl.clientTop || body.clientTop || 0
      let clientLeft = docEl.clientLeft || body.clientLeft || 0

      let top = box.top + scrollTop - clientTop
      let left = box.left + scrollLeft - clientLeft

      return {
        t: Math.round(top),
        l: Math.round(left),
        h: elem.offsetHeight,
        w: elem.offsetWidth
      }
    },
    closeOnMouseLeave () {
      let pos = this.getElementPosition()
      let offset = 25

      if (!(this.mouseX > (pos.l - offset) && this.mouseX < (pos.l + pos.w + offset) &&
        this.mouseY > (pos.t - offset) && this.mouseY < (pos.t + pos.h + offset))) {
        this.hide()
      }
    },
    show (data) {
      this.data = data
      this.visible = true
      this.setPosition()
    },
    hide () {
      this.visible = false
    },
    setPosition () {
      let positionStyle = {
        top: 'auto',
        bottom: 'auto',
        left: 'auto',
        right: 'auto'
      }

      if (this.mouseX > (window.innerWidth - 200)) {
        positionStyle.right = parseInt(window.innerWidth - this.mouseX + this.positionOffset.x) + 'px'
      } else {
        positionStyle.left = parseInt(this.mouseX + this.positionOffset.x) + 'px'
      }

      if (this.mouseY > (window.innnerHeight - 80)) {
        positionStyle.bottom = parseInt(window.innnerHeight - this.mouseY + this.positionOffset.y) + 'px'
      } else {
        positionStyle.top = parseInt(this.mouseY + this.positionOffset.x) + 'px'
      }

      this.positionStyle = positionStyle
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/components/sass/shared/colors';
@import '~@/components/sass/shared/fonts';
@import '~@/components/sass/placeholders/tooltip';
@import '~@/components/sass/mixins/flexbox-grid';

.mouse-tooltip__tooltip{
  @extend %tooltip;
  align-items: center;
  position: absolute;
  max-width: 480px;
}

.linetooltip{}

.linetooltip__label{
  font-family: $fontfamily-serif;
  font-size: 15px;
  font-weight: 100;
  flex: 0 0 100%;
}

.linetooltip__year{ flex: 0 0 50%; }

.map__value,
.linetooltip__value{
  font-size: 13px;
  font-weight: bold;
  text-align: right;
}

.linetooltip__value{
  flex: 0 0 50%;
  text-align: right;
}

.map{
  min-width: 100px;

  &__wrap {
    display: flex; -js-display: flex;

    &__label{
      flex: 1 1 60%;
      font-family: $fontfamily-serif;
      font-size: 15px;
      margin-bottom: 0 !important;
      padding-right: 10px;
    }

    &__value{
      flex: 1 1 40%;
      margin-bottom: 0 !important;
      text-align: right;
    }
  }

  &__sublabel {
    flex: 1 1 100%;
    font-size: 11px;
    font-style: italic;
    margin-top: 3px !important;
  }
}



.multiline{
  min-width: 100px;

  &__label{
    font-family: $fontfamily-serif;
    font-size: 15px;
    margin-bottom: 0 !important;
  }

  &__sublabel{
    font-size: 11px;
    font-style: italic;
    margin-bottom: 5px !important;
  }

  &__values {
    &__value {
      font-size: 12px;
      line-height: 1.2;
    }
  }
}

.country-info{
  background: #ffffff;
  color: #064c65;
  margin: -.5em -1em;
  padding: 0 0 .5em;
  .multiline__label{
    background:#f1f3f7;
    font-weight: bold;
    padding: .5em 1em;
  }
  .multiline__values{
    padding: .5em 1em;
  }
  .multiline__values__value{
    width:220px;
    display:flex;
    justify-content: space-between;
    padding: .5em 0;
    border-bottom: 1px dotted #064c65;
    span{
      min-width: 24px;
    }
  }
}
.linetooltip__row{
  display: flex; -js-display: flex;

  &> *:first-child{
    padding-right: 10px;
  }
  &> *{
    flex: 1 1 50%;
    margin-bottom: 0 !important;
  }
}

.linetooltip .inner + .inner {
  margin-top: 10px;
}

.germany{
  .linetooltip__row{ margin-top: 0.5em }
  .linetooltip__row:first-child{ margin-top: 0 }
}

.single__link {
  color: $gray-light;
  cursor: pointer;
  display: block;

  &:hover {
    color: $gray-lighter;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/shared/misc/MouseTooltip.vue